export const parseCountdownDate = (timestamp: string | undefined) => {
  if (!timestamp || timestamp?.includes('.')) {
    return timestamp
  }

  return `${timestamp}.000-03:00`
}
